import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

function loadScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function checkout(orderBody, onSuccess) {
  if (!(await loadScript())) return toast.error("Could not load payment gateway");
  let o;
  try {
    o = (await api.post("/checkout/order", orderBody)).data;
  } catch (e) {
    return toast.error(errMsg(e));
  }
  if (o.test) toast.info("TEST MODE: admin purchase uses Razorpay test keys. Use a test card (e.g. 4111 1111 1111 1111) or success@razorpay UPI; no real money is charged.", { duration: 9000 });
  const rzp = new window.Razorpay({
    key: o.key_id,
    amount: o.amount,
    currency: o.currency,
    order_id: o.rzp_order_id,
    name: o.test ? "CCMIntel (TEST MODE)" : "CCMIntel",
    description: o.description,
    image: `${window.location.origin}/logo.png`,
    prefill: { name: o.name, email: o.email },
    theme: { color: "#1074BA" },
    handler: async (res) => {
      try {
        await api.post("/checkout/verify", res);
        toast.success("Payment successful");
        onSuccess?.();
      } catch (e) {
        toast.error(errMsg(e));
      }
    },
  });
  rzp.on("payment.failed", (r) => toast.error(r.error?.description || "Payment failed"));
  rzp.open();
}
